import { useCallback } from "react";

import { useLocale, type MessageKey } from "../../shared/i18n";
import {
  adminShellMessages,
  type AdminShellMessageKey,
} from "../../shared/i18n/adminShellMessages";

export type ShellKey = MessageKey | AdminShellMessageKey;
export type ShellTranslate = (key: ShellKey) => string;

function isShellKey(key: ShellKey): key is AdminShellMessageKey {
  return key in adminShellMessages;
}

/**
 * Translator that resolves shell keys from adminShellMessages first and
 * everything else from the shared catalog. Keeps the shell working without a
 * registration in messages.ts.
 */
export function useShellT(): ShellTranslate {
  const { locale, t } = useLocale();
  return useCallback(
    (key: ShellKey) =>
      isShellKey(key) ? adminShellMessages[key][locale] : t(key),
    [locale, t],
  );
}
